import {
    UPDATECHARGEBACK_SUCCESS,
    UPDATECHARGEBACK_FAILED,
    RESET_UPDATECHARGEBACK,
    LOADING_UPDATECHARGEBACK,
    NETWORK_ERROR_UPDATECHARGEBACK,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UPDATECHARGEBACK:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case UPDATECHARGEBACK_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case UPDATECHARGEBACK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_UPDATECHARGEBACK:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_UPDATECHARGEBACK:
            return (state = initialState);
        default:
            return state;
    }
};